<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="PolicySystemStatusCollection"
  />
</template>

<script>
import { DropDownSectionConsts, PolicyStatusConsts } from 'client/util/Constants';
import { mapActions } from 'vuex';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const { failed, pending, success } = PolicyStatusConsts;

const {
  selectOne,
} = DropDownSectionConsts;

export default {
  name: 'PolicySystemStatusDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    const filters = {
      success: string => ({
        name: 'state',
        operator: 'eq',
        value: string.toUpperCase(),
        // The following two props are used to display in filter pill. (type : displayValue)
        type: 'status',
        displayValue: string,
      }),
    };

    const dropDownMenuSections = [
      {
        menuLabel: 'policy status:',
        menuType: selectOne,
        menuItems: [
          {
            filter: filters.success(success),
            label: success,
            action: () => {
              this.handleDropDownAction(filters.success(success));
            },
          },
          {
            filter: filters.success(pending),
            label: pending,
            action: () => {
              this.handleDropDownAction(filters.success(pending));
            },
          },
          {
            filter: filters.success(failed),
            label: failed,
            action: () => {
              this.handleDropDownAction(filters.success(failed));
            },
          },
        ],
      },
    ];

    return {
      dropDownMenuSections,
      filters,
    };
  },

  methods: {
    ...mapActions('PolicySystemStatusCollection', [
      'setFilter',
      'fetchCollection',
    ]),
  },
};
</script>
